export const hideToolTip = (id) => {
  return setTimeout(() => {}, 1500);
};

export const handleNumber = (number) => {
  // if (number % 1 === 0) {
  //   return number;
  // }
  let finalNum =
    parseFloat(Number(number)).toFixed(2) !== "NaN"
      ? parseFloat(Number(number)).toFixed(2)
      : parseFloat(Number(0.1)).toFixed(2);
  return finalNum;
};

export const errorMsgCard = (message) => {
  return (
    <div
      className="bg-danger-light mt-3 vcenter-item  ml-auto p-3 text-dark"
      style={{ borderRadius: 15 }}
    >
      <svg
        width="40"
        height="40"
        viewBox="0 0 34 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.285 1.98614L0.383385 25.7951C0.132273 26.2251 4.64755e-05 26.7128 1.22494e-08 27.2094C-4.6451e-05 27.7059 0.132088 28.1936 0.38312 28.6236C0.634152 29.0536 0.995234 29.4107 1.43007 29.659C1.8649 29.9072 2.35815 30.0379 2.86025 30.0378H30.6612C31.1633 30.0379 31.6566 29.9072 32.0914 29.659C32.5262 29.4107 32.8873 29.0536 33.1384 28.6236C33.3894 28.1936 33.5215 27.7059 33.5215 27.2094C33.5214 26.7128 33.3892 26.2251 33.1381 25.7951L19.238 1.98614C18.987 1.55627 18.626 1.1993 18.1913 0.951111C17.7566 0.702925 17.2634 0.572266 16.7615 0.572266C16.2595 0.572266 15.7664 0.702925 15.3317 0.951111C14.897 1.1993 14.536 1.55627 14.285 1.98614Z"
          fill="#EE404C"
        />
        <path
          d="M16.9425 9.3291H16.5799C15.6871 9.3291 14.9634 10.0448 14.9634 10.9277V18.5686C14.9634 19.4515 15.6871 20.1672 16.5799 20.1672H16.9425C17.8353 20.1672 18.5591 19.4515 18.5591 18.5686V10.9277C18.5591 10.0448 17.8353 9.3291 16.9425 9.3291Z"
          fill="#FFF7ED"
        />
        <path
          d="M16.7612 26.2272C17.7542 26.2272 18.5591 25.4312 18.5591 24.4493C18.5591 23.4674 17.7542 22.6714 16.7612 22.6714C15.7683 22.6714 14.9634 23.4674 14.9634 24.4493C14.9634 25.4312 15.7683 26.2272 16.7612 26.2272Z"
          fill="#FFF7ED"
        />
      </svg>
      <p className="regularText lineHeight21 mb-0 ml-3">{message}</p>
    </div>
  );
};

